<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 30 30"
    :color="color"
    title="Ícone Link Externo"
  >
    <!-- eslint-disable max-len -->
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM15.6667 11.6667H18.3333C20.1733 11.6667 21.6667 13.16 21.6667 15C21.6667 16.84 20.1733 18.3333 18.3333 18.3333H15.6667V17H18.3333C19.4333 17 20.3333 16.1 20.3333 15C20.3333 13.9 19.4333 13 18.3333 13H15.6667V11.6667ZM11.6667 17H14.3333V18.3333H11.6667C9.82667 18.3333 8.33333 16.84 8.33333 15C8.33333 13.16 9.82667 11.6667 11.6667 11.6667H14.3333V13H11.6667C10.5667 13 9.66667 13.9 9.66667 15C9.66667 16.1 10.5667 17 11.6667 17ZM17.6667 14.3333H12.3333V15.6667H17.6667V14.3333Z"
    />
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

export default {
  components: {
    BaseIcon,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 72,
    },
    height: {
      type: [Number, String],
      default: 72,
    },
  },
};
</script>
